import React, { useState } from "react";
import { Modal, Button, Col, Row } from "antd";
import { useFormikContext } from "formik";
import moment from "moment";
import { labelTranslator, timestampToDate } from "./helper/helper";

const submitButtonStyle = {
  float: "right",
  border: "none",
  width: "30%",
  borderRadius: 10,
  fontWeight: 600,
};
const ConfirmationPopup = (props) => {
  const [visible, setVisible] = useState(false);
  const [isDataConfirmed, setIsDataConfirmed] = useState(false);
  const { submitForm } = useFormikContext();
  const handleConfirmation = () => {
    setIsDataConfirmed(true);
    setVisible(false);
  };
  const displayConfirmation = () => {
    setVisible(true);
    setIsDataConfirmed(false);
  };
  const handleCancel = () => {
    setVisible(false);
    setIsDataConfirmed(false);
  };
  const displayFields = (key) => {
    if (props.values[key] === "na") {
      return false;
    }
    if (key === "validTill") {
      return true;
    }
    return (
      props.values[key] &&
      key !== "comments" &&
      key !== "status" &&
      props.values["status"] !== "Activated"
    );
  };
  const formatValue = (key) => {
    if (key === "validTill" || key === "exitedAt") {
      return timestampToDate(props.values[key]);
    } else if (key === "expiry" || key === "quickTradeType") {
      return labelTranslator(props.values[key]);
    } else {
      return props.values[key];
    }
  };
  return (
    <>
      <Button
        loading={props.loading}
        disabled={props.disabled}
        onClick={() => displayConfirmation()}
        className="formInput"
        style={
          props.loading
            ? { ...submitButtonStyle, backgroundColor: "#ffc400" }
            : { ...submitButtonStyle, backgroundColor: "#f1f1f5" }
        }
      >
        Done
      </Button>
      <Modal
        title={props.title}
        centered
        visible={visible}
        footer={null}
        onCancel={() => handleCancel()}
        style={{ borderRadius: 10, zIndex: 1050 }}
      >
        <Row>
          {/* <Col style={{ textAlign: "left" }} span={12}>
            <div
              style={{
                color: "#808080",
                fontSize: 10,
                fontWeight: 500,
              }}
            >
              Trade Date
            </div>
            <div
              style={{
                color: "#0b1721",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {timestampToDate(props.values["exitedAt"])}
            </div>
          </Col> */}
          {props.values["status"] ? (
            <Col style={{ textAlign: "left" }} span={12}>
              <div
                style={{
                  color: "#808080",
                  fontSize: 10,
                  fontWeight: 500,
                }}
              >
                Status
              </div>
              <div
                style={{
                  color: "#0b1721",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {props.values["status"]}
              </div>
            </Col>
          ) : (
            <div />
          )}
          {Object.keys(props.values).map((key, index) =>
            displayFields(key) ? (
              // props.values[key] && key !== "comments" && key !== "status" && props.values["status"] !== "Activated"? (
              <Col style={{ textAlign: "left" }} span={12}>
                <div
                  style={{
                    color: "#808080",
                    fontSize: 10,
                    fontWeight: 500,
                  }}
                >
                  {labelTranslator(key)}
                </div>
                <div
                  style={{
                    color: "#0b1721",
                    fontSize: 12,
                    fontWeight: "bold",
                  }}
                >
                  {formatValue(key)}
                </div>
              </Col>
            ) : (
              <div />
            )
          )}
          {props.values["comments"] ? (
            <Col style={{ textAlign: "left" }} span={24}>
              <div
                style={{
                  color: "#808080",
                  fontSize: 10,
                  fontWeight: 500,
                }}
              >
                Comments
              </div>
              <div
                style={{
                  color: "#0b1721",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {props.values["comments"] || ""}
              </div>
            </Col>
          ) : (
            <div />
          )}
        </Row>
        <br />
        <Button
          type="primary"
          loading={props.loading}
          disabled={props.disabled}
          htmlType="submit"
          onClick={() => {
            submitForm();
            setVisible(false);
          }}
          style={submitButtonStyle}
          className="formInput"
        >
          Confirm
        </Button>
        <br />
        <br />
      </Modal>
    </>
  );
};

export default ConfirmationPopup;
